/**
 * Guard: Apollo readFragment expects a DocumentNode with .definitions (HELP-10463).
 * If fragment is undefined/invalid (e.g. import or build issue), skip to avoid
 * "Cannot read properties of undefined (reading 'definitions')".
 */
export const isValidGqlFragment = (fragment: unknown): boolean =>
  fragment != null &&
  typeof fragment === "object" &&
  "definitions" in fragment &&
  Array.isArray(fragment.definitions);
